import { IconProps } from './types'

export const DeleteIcon = ({width = 12, height = 12, fill = 'currentColor'}: IconProps) => {
  return <svg width={width} height={height} viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M0.838193 0.671573C0.603877 0.905888 0.603877 1.28579 0.838193 1.5201L2.81809 3.5L0.838193 5.4799C0.603877 5.71421 0.603877 6.09411 0.838193 6.32843C1.07251 6.56274 1.45241 6.56274 1.68672 6.32843L3.66662 4.34853L5.64652 6.32843C5.88083 6.56274 6.26073 6.56274 6.49505 6.32843C6.72936 6.09411 6.72936 5.71421 6.49505 5.4799L4.51515 3.5L6.49505 1.5201C6.72936 1.28579 6.72936 0.905888 6.49505 0.671573C6.26073 0.437258 5.88083 0.437257 5.64652 0.671573L3.66662 2.65147L1.68672 0.671573C1.45241 0.437258 1.07251 0.437257 0.838193 0.671573Z"
          fill={fill}/>
  </svg>

}